import React from "react";
import tw from "twin.macro";
import { Link as RouterLink } from "react-router-dom";
import NewsletterForm from "components/forms/NewsletterForm";

const Container = tw.div`relative bg-gray-200 -mx-8 -mb-8 px-8 pt-16 text-center`;
const Columns = tw.div`max-w-screen-xl mx-auto flex flex-wrap justify-between`;

const Column = tw.div`w-full md:w-1/2 lg:w-1/2 mb-12 text-left`;
const CompanyDescription = tw.p`mt-6 font-medium text-sm `;

const ColumnHeading = tw.h5`font-bold text-lg`;
const SubscribeContainer = tw.div` ml-12`;
const SubscribeText = tw.p`mt-6 text-sm font-medium text-gray-600`;
const LegalLinksRow = tw.div`flex flex-wrap justify-center gap-6 mt-4 text-sm font-medium text-gray-700`;
const StyledLink = tw(RouterLink)`border-b-2 border-transparent hocus:text-primary-500 hocus:border-primary-500 transition duration-300`;

const CopywrightNotice = tw.p`text-center font-medium text-sm mt-6 pb-8`;

export default () => {
  return (
    <Container>
      <Columns>
        {/* Column 1: Logo + Description + Socials */}
        <Column>
          <ColumnHeading>Who we are</ColumnHeading>
          <CompanyDescription>
            EthosHub is a secure, anonymous workplace incident reporting platform designed to help organisations address and prevent bullying, harassment, discrimination and more.
          </CompanyDescription>
        </Column>

        {/* Column 2: Newsletter */}
        <Column>
          <SubscribeContainer>
            <ColumnHeading>Subscribe to our Newsletter</ColumnHeading>
            <SubscribeText>
              Practical guidance for HR teams on workplace conduct, reporting and investigations. No spam.
            </SubscribeText>
          <NewsletterForm />
          </SubscribeContainer>
        </Column>
      </Columns>

      {/* Legal Links in a Row */}
      <LegalLinksRow>
        <StyledLink to="/gdpr">GDPR</StyledLink>
        <StyledLink to="/privacy-policy">Privacy Policy</StyledLink>
        <StyledLink to="/terms-of-service">Terms of Service</StyledLink>
        <StyledLink to="/disclaimer">Disclaimer</StyledLink>
      </LegalLinksRow>

      <CopywrightNotice>&copy; 2026 EthosHub.io | All Rights Reserved.</CopywrightNotice>
    </Container>
  );
};